
/*jshint multistr: true */
/*jshint esversion: 6 */


$(function () {

    const providerYT1 = 'youtube';
    const providerYT2 = 'youtu.be';
    const providerVimeo = 'vimeo';
    const providerCDN = 'CDN';
    const markers = [25, 50, 75];

    const HOLAEnabled = $('body').data('hola') === 'enabled';

    const disablePrerol = $('body').data('bodyextrainfo') && $('body').data('bodyextrainfo').includes('no_preroll');
    const didomiDisabled = document.querySelector('body').dataset.didomiDisabled === 'True';

    let playersMarkers = [];
    let bannersEnabled = false;
    let isMuted = true;
    let windowWidth = $(window).width();
    let headerHeight = $('.header_wrapper').outerHeight();
    let consentForBasicAds = false;
    let consentForPersonalizedAds = false;

    function findObjectIndexById(haystack, key, needle) {
        for (let i = 0; i < haystack.length; i++) {
            if (haystack[i][key] === needle) {
                return i;
            }
        }
        return null;
    }


    function eventToGA(thisObject, eventType) {

        let eventName;

        if (thisObject.currentSrc()) {
            eventName = thisObject.currentSrc();
        } else {
            eventName = 'not set';
        }

        dataLayer.push({
            event: 'video',
            eventCategory: 'Video',
            eventAction: eventType,
            eventLabel: eventName
        });
    }


    function trackProgress(player) {

        player.on('timeupdate', function (e) {

            const percentPlayed = Math.floor(player.currentTime() * 100 / player.duration());

            const playerMarkerID = player.id_;
            const playerMarkerIndex = findObjectIndexById(playersMarkers, 'id', playerMarkerID);

            if (markers.includes(percentPlayed) && !playersMarkers[playerMarkerIndex].markers.includes(percentPlayed)) {
                playersMarkers[playerMarkerIndex].markers.push(percentPlayed);
                eventToGA(this, `${percentPlayed}%`);
            }
        });
    }


    function trackPause(player) {

        player.on('pause', function (e) {
            let remainingTime = player.remainingTime();

            const playerMarkerIndex = findObjectIndexById(playersMarkers, 'id', player.id_);
            if (playersMarkers[playerMarkerIndex].paused) { return; }
            playersMarkers[playerMarkerIndex].paused = true;

            if (remainingTime != 0) {
                eventToGA(this, 'Paused video');
            }
        });
    }


    function applyVideoAnalytics(player) {
        // videojs on events: loadstart, sourceset, waiting, ended, seeking, play, firstplay, durationchange, fullscreenchange, error, loadedmetadaa, posterchange, textdata, ratechange timeupdate

        // init player tracking object
        playersMarkers.push({
            'id': player.id_,
            'markers': [],
            'played': false,
            'paused': false
        });


        player.on('play', function (e) {
            const playerMarkerIndex = findObjectIndexById(playersMarkers, 'id', player.id_);
            if (playersMarkers[playerMarkerIndex].played) { return; }
            playersMarkers[playerMarkerIndex].played = true;
            eventToGA(this, 'Played video');
        });


        if (windowWidth >= 1200) {

            player.on('pause', function (e) {
                let remainingTime = player.remainingTime();
                const playerMarkerIndex = findObjectIndexById(playersMarkers, 'id', player.id_);
                if (playersMarkers[playerMarkerIndex].paused) { return; }
                playersMarkers[playerMarkerIndex].paused = true;

                if (remainingTime != 0) {
                    eventToGA(this, 'Paused video');
                }
            });

            player.on('ended', function (e) {
                eventToGA(this, '100%');
            });

            player.on('error', function (e) {
                eventToGA(this, 'Video error');
            });

            player.on('adsready', function () {
                bannersEnabled = true;
            });

            if (bannersEnabled === true) {

                player.ima.addEventListener(google.ima.AdEvent.Type.COMPLETE, function () {
                    trackProgress(player);
                });

            } else {
                trackProgress(player);
            }

        } else {

            player.on('vast.adEnd', e => {

                player.on('ended', function (e) {
                    eventToGA(this, '100%');
                });

                player.on('error', function (e) {
                    eventToGA(this, 'Video error');
                });

                trackProgress(player);
                trackPause(player);
            });

            player.on('vast.adError', e => {
                player.on('ended', function (e) {
                    eventToGA(this, '100%');
                });

                player.on('error', function (e) {
                    eventToGA(this, 'Video error');
                });
                trackProgress(player);
                trackPause(player);
            });
        }
    }


    function setVideoPlayer(videoSlot, videoURL, muted) {

        let prerollTag = '';

        // if didomi is disabled or the user enabled both ads consents, fill the preroll tag
        if (didomiDisabled || (consentForBasicAds && consentForPersonalizedAds)) {

            prerollTag = `https://pubads.g.doubleclick.net/gampad/ads?sz=640x360|504x338|600x400|620x380&iu=/18981092/Autostart_Video_PreRoll${getArticleSectionSlug()}&impl=s&gdfp_req=1&env=vp&output=xml_vast2&unviewed_position_start=1&url=autostart.24sata.hr&description_url=[description_url]&correlator=${new Date().getTime()}`;
        }

        // must add timeout on play-> to play ads you need to play video first, and due to loading times for scripts you can see few miliseconds of video before it is actualy paused to play add
        // https://github.com/googleads/videojs-ima/issues/167
        let playerInstance = videojs(videoSlot[0], { 'html5': { 'hls': { 'overrideNative': true } }, 'autoplay': false, 'preload': 'auto', 'prerollTimeout': 500, 'timeout': 5000, 'muted': muted }),
            videoID = playerInstance.id();

        // defining controls inside options doesn't work for some odd reason
        playerInstance.controls(true);

        playerInstance.src({ type: 'video/mp4', src: videoURL });

        var shareOptions = {
            socials: ['fbFeed', 'messenger', 'tw', 'viber', 'email'],
            url: window.location.href,
            image: playerInstance.poster(),
            // required for Facebook and Messenger
            fbAppId: '412582762167121',
            // optional for Facebook
            redirectUri: window.location.href + '#close',
        }

        playerInstance.share(shareOptions);

        // if prerol is disabled, do not call ima plugin because it creates bug in play-pause interaction on autoplay

        if (windowWidth >= 1200) {

            if (disablePrerol) {

                prerollTag = '';

            } else if (didomiDisabled || (consentForBasicAds && consentForPersonalizedAds)) {

                var options = {
                    id: videoID,
                    adTagUrl: prerollTag,
                    adLabel: 'Reklama'
                };

                playerInstance.ima(options);
            }

        } else {

            if (disablePrerol) {

                prerollTag = '';

            } else if (didomiDisabled || (consentForBasicAds && consentForPersonalizedAds)) {

                const adsCancelTimeout = 10000; // if not downloaded in this time, skip it

                playerInstance.vastClient({
                    adTagUrl: prerollTag,
                    playAdAlways: true,
                    adCancelTimeout: adsCancelTimeout,
                    adsEnabled: true
                });
            }

            // tap on mobile devices to toggle play/pause
            playerInstance.on('touchstart', function ({ target }) {
                if (target.nodeName === 'VIDEO') {
                    if (playerInstance.paused()) {
                        this.play();
                    } else {
                        this.pause();
                    }
                }
            });

            playerInstance.on('seeking', e => {
                if (playerInstance.currentTime() === 0) {
                    playerInstance.addClass('vjs-looping');
                }
            });

            playerInstance.on('playing', e => {
                if (playerInstance.currentTime() === 0) {
                    playerInstance.removeClass('vjs-looping');
                }
            });
        }

        applyVideoAnalytics(playerInstance);
    }


    $.fn.inViewHalfPageDesktop = function () {

        const $win = $(window);
        const scrollPosition = $win.scrollTop();
        const headerOffset = headerHeight;
        const $obj = $(this);
        const visibleArea = $win.height() / 2 + scrollPosition + headerOffset; // upper half of screen
        const objStartPos = $obj.offset().top + $obj.outerHeight() / 2;

        return visibleArea >= objStartPos && scrollPosition <= objStartPos;
    };


    // Autoplay video when player come into view
    const setVideoAutoplayDesktop = (videoSlot, videoURL) => {

        setVideoPlayer(videoSlot, videoURL, true);

        let videoPlayerInstance = videojs(videoSlot[0]),
            userInteracted = false,
            adPlaying = false,
            videoActive = false;

        function videoEventHandler(event) {
            userInteracted = true;
        }

        // this events are not stackable! can not use on('play pause seeked')

        videoPlayerInstance.on('play', videoEventHandler);
        videoPlayerInstance.on('pause', videoEventHandler);
        videoPlayerInstance.on('volumechange', function () {
            isMuted = false;
        });

        videoPlayerInstance.on('seeked', videoEventHandler);

        function checkTopPositionVideo() {

            let videoIsInView = videoSlot.inViewHalfPageDesktop();

            // we autoplay video if it is in upper half on page, 
            // never been interected with and we have to pause  if user scrolls away. 
            // then we don't autoplay it again! autoplayed video must be muted
            if (!userInteracted && videoIsInView) {
                videoPlayerInstance.play();
                videoActive = true;

                // if didomiDisabled is false, or consents are false or undefined, or disablePrerol is true stop here
                if (!didomiDisabled || !consentForBasicAds || !consentForPersonalizedAds || disablePrerol) return;

                videoPlayerInstance.ima.addEventListener(google.ima.AdEvent.Type.STARTED, function () {
                    adPlaying = true;
                });
                videoPlayerInstance.ima.addEventListener(google.ima.AdEvent.Type.COMPLETE, function () {
                    if (isMuted) {
                        videoPlayerInstance.muted(true);
                        videoPlayerInstance.volume(0);
                    }

                    videoPlayerInstance.play(true);
                });

            } else if (userInteracted && videoActive && !videoIsInView) {

                videoPlayerInstance.pause();
                videoActive = false;

                if (adPlaying && !disablePrerol) {
                    videoPlayerInstance.ima.pauseAd();
                }

            } else if (userInteracted) {
                videoPlayerInstance.muted(false);
                videoPlayerInstance.volume(1);
            }
        }

        $(window).scroll($.throttle(800, checkTopPositionVideo));
    };


    $.fn.inViewHalfPageMobile = function (id) {
        const $win = $(window);
        const scrollPosition = $win.scrollTop();
        const headerOffset = headerHeight;
        const $obj = $('#' + id);
        const visibleArea = $win.height() / 2 + scrollPosition + headerOffset; // upper half of screen
        const objStartPos = $obj.offset().top + $obj.outerHeight() / 2;

        return visibleArea >= objStartPos && scrollPosition <= objStartPos;
    };


    const setVideoAutoplayMobile = (videoSlot, videoURL) => {
        setVideoPlayer(videoSlot, videoURL, true);

        let videoPlayerInstance = videojs(videoSlot[0]);
        let userInteracted = false;
        let adPlaying = false;
        let videoActive = false;

        function videoEventHandler(event) {
            userInteracted = true;
        }

        // this events are not stackable! can not use on('play pause seeked')

        videoPlayerInstance.on('play', videoEventHandler);
        videoPlayerInstance.on('pause', videoEventHandler);
        videoPlayerInstance.on('seeked', videoEventHandler);

        function checkTopPositionVideo() {

            let videoIsInView = videoSlot.inViewHalfPageMobile(videoPlayerInstance.id_);
            let Component = videojs.getComponent('Component');
            let button = videoPlayerInstance.getChild('BigPlayButton');

            // we autoplay video if it is in upper half on page, 
            // never been interected with and we have to pause  if user scrolls away. 
            // then we don't autoplay it again! autoplayed video must be muted

            if (!userInteracted && videoIsInView) {
                videoPlayerInstance.muted(true);
                videoPlayerInstance.volume(0);
                button.trigger('click');

                videoActive = true;

                if (!disablePrerol) {
                    videoPlayerInstance.on('vast.adStart', () => {
                        videoPlayerInstance.muted(true);
                        videoPlayerInstance.volume(0);
                        adPlaying = true;
                    });

                    videoPlayerInstance.on('vast.adEnd', () => {
                        videoPlayerInstance.muted(true);
                        videoPlayerInstance.volume(0);
                        button.trigger('click');
                    });
                }

            } else if (userInteracted && videoActive && !videoIsInView) {

                videoPlayerInstance.pause(true);
                videoActive = false;

                if (adPlaying && !disablePrerol) {
                    videoPlayerInstance.vast.pauseAd();
                }
            }
        }

        $(window).scroll($.throttle(800, checkTopPositionVideo));
    };


    // set youtube or vimeo embeded player
    const setEmbededPlayer = (videoSlot, videoURL, videoProvider) => {

        const fWidth = '100%';
        const fHeight = '100%';

        let iframeSrc = '';
        let paddBott = 56.3;

        // YT, Vimeo works with 1=true 0=false (explicitly set autoplay to true, 1 or false, zero, not set (=undefined)
        let autoplay = (autoplay) ? 1 : 0;
        if (videoProvider === providerYT1) {

            // regexp for extracting youtube video ID - works with playlists, time ...
            const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
            const match = videoURL.match(regExp);
            let ytMovieID = (match && match[7].length === 11) ? match[7] : false;

            if (!ytMovieID) { return; } // break if not valid youtube ID

            iframeSrc = `//www.youtube.com/embed/${ytMovieID}?autoplay=${autoplay}&origin=https://www.24sata.hr`;

            // set padding here if aspect ratio change
            // paddBott = 56.3; // 66.6; // old value just in case

        } else if (videoProvider === providerVimeo) {
            // regexp for extracting vimeo video ID - works with channel, playlist ...
            const regExp = /(videos|video|channels|\.com)\/([\d]+)/;
            const match = videoURL.match(regExp);
            let vimeoMovieID = (match && match[2]) ? match[2] : false;

            if (!vimeoMovieID) { return; }// break if not valid vimeo ID

            iframeSrc = `//player.vimeo.com/video/${vimeoMovieID}?autoplay=${autoplay}&color=00adef`;
        }


        // creating Video iframe
        const $videoIframe = `<iframe class="embeded_${videoProvider}_player" width="${fWidth}" height="${fHeight}" frameborder="0" style="position: absolute;"
                            src="${iframeSrc}" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>`;

        // getting Video container
        const $videoContainer = videoSlot;

        $videoContainer
            .html('')
            .css({
                'display': 'block',
                'position': 'relative',
                'height': '0',
                'width': fWidth,
                'padding-bottom': paddBott + '%'
            });

        $videoContainer.append($($videoIframe));
    };


    const inlinePlayerInit = () => {
        let video = $('.js_videoPlayer');

        if (video.length === 0) { return; }

        else {

            video.each(function () {
                let videoSlot = $(this),

                    videoURL = videoSlot.data('videourl'),
                    videoProvider = getVideoProvider(videoURL);

                if (videoProvider === 'CDN') {
                    if (!HOLAEnabled) {

                        if (windowWidth >= 1200) {
                            setVideoAutoplayDesktop(videoSlot, videoURL);
                        } else {
                            setVideoAutoplayMobile(videoSlot, videoURL);
                        }

                    } else {
                        setVideoPlayer(videoSlot, videoURL, false);
                    }
                } else {
                    setEmbededPlayer(videoSlot, videoURL, videoProvider);
                }
            });
        }
    };


    $.fn.inView = function () {
        const portion = 4;
        const win = $(window);
        const headerOffset = headerHeight;
        let obj = $(this);

        // detekcije jel u drugoj trećini ekrana
        const scrollPosition = win.scrollTop() + (win.height() / portion) + headerOffset; // pomak za trećinu + header
        const visibleArea = win.scrollTop() + (win.height() / portion * 2) + headerOffset; // gornja trećina ekrana
        const objEndPos = obj.offset().top + obj.outerHeight();

        return (visibleArea >= objEndPos && scrollPosition <= objEndPos ? true : false);
    };


    // get article section for preroll targeting
    const getArticleSectionSlug = () => {

        let articleSectionSlug = '';
        const $articleContent = $('.article__content');

        //if in article
        if ($articleContent.length > 0) {

            let articleSectionData = $articleContent.data('section-slug');
            let articleSubsectionData = $articleContent.data('subsection-slug');
            let articleID = $articleContent.data('article-id');

            if (articleSectionData !== '') {
                articleSectionSlug = `&cust_params=section%3D${articleSectionData}`;
            }

            if (articleSubsectionData !== '') {
                articleSectionSlug += `%26sub_sec%3D${articleSubsectionData}`;
            }

            if (articleID !== '') {
                articleSectionSlug += `%26articleID%3D${articleID}`;
            }
        }

        return articleSectionSlug;
    };


    // returns vimeo, youtube, CDN
    const getVideoProvider = videoURL => {

        if (videoURL && (videoURL.includes(providerYT1) || videoURL.includes(providerYT2))) {
            return providerYT1;
        }

        if (videoURL && videoURL.includes(providerVimeo)) {
            return providerVimeo;
        }

        return providerCDN;
    };


    const setInArticlePreroll = () => {

        if (windowWidth >= 1200) {

            // disabling preroll on sections
            if (disablePrerol) { return; }

            const $articleContent = $('.article__content');

            const prerollID = 'inArticlePreroll';
            let $prerollContainer;

            let prerollInstance;
            let prerollExit = false;

            function checkTopPosition() {

                prerollInstance = videojs('inArticlePreroll');

                if (!prerollExit && $prerollContainer.length) {

                    if ($prerollContainer.inView()) {
                        prerollInstance.play();

                    } else {
                        prerollInstance.pause();
                    }
                }
            }

            const destroyInArticlePreroll = (videoPlayerInstance) => {

                $prerollContainer.css({
                    'height': '0',
                    'padding-bottom': '0',
                    'margin-bottom': '0'
                });

                // after 500ms (css-transition) remove InArticlePreroll video
                setTimeout(() => {
                    videoPlayerInstance.dispose()
                }, 500);

            };

            const createInArticlePreroll = () => {

                // check if we are on article page
                if (!$articleContent.length) { return; }

                const paragraphs = $articleContent.find('p').length;
                const halfParagr = Math.ceil(paragraphs / 2);

                // create player in the middle of article
                const inArticlePosition = $articleContent.find('p').eq(halfParagr);
                const inArticleContent = `<div id="${prerollID}_container" class="article__video_wrap video" style="position: relative;                                       width:100%; height:0px; padding-bottom: 0; visibility:hidden; transition: all 0.5s;         z-index: 1; overflow: hidden;">
                                                <video id="${prerollID}" class="video-js">
                                                    <source src="/static/video/blank_video.mp4" type="video/mp4">
                                                </video>
                                            </div>`;
                inArticlePosition.append(inArticleContent);
                $prerollContainer = $(`#${prerollID}_container`);

                const prerollTag = `https://pubads.g.doubleclick.net/gampad/ads?sz=640x360|504x338|600x400|620x380|640x380&iu=/18981092/Autostart_Video_InArticle${getArticleSectionSlug()}&impl=s&gdfp_req=1&env=vp&output=xml_vast2&unviewed_position_start=1&url=autostart.24sata.hr&description_url=[description_url]&correlator=${new Date().getTime()}`;

                if (inArticlePosition.length) {
                    let videoPlayerInstance = videojs('inArticlePreroll', {
                        controls: false,
                        autoplay: false,
                        preload: 'auto',
                        muted: true
                    }),
                        videoID = videoPlayerInstance.id_;


                    // options for preroll banner
                    var options = {
                        id: videoID,
                        adTagUrl: prerollTag,
                        adLabel: 'Reklama'
                    };

                    videoPlayerInstance.ima(options);

                    videoPlayerInstance.on('adsready', function () {
                        videoPlayerInstance.ima.addEventListener(google.ima.AdEvent.Type.STARTED, function () {

                            $(`#${prerollID}_container`).css({
                                'visibility': 'visible',
                                'padding-bottom': '56.3%',
                                'margin-bottom': '20px',
                                'margin-top': '20px'
                            });

                            $(`#${prerollID}`).css({
                                'position': 'absolute'
                            });
                        });

                        videoPlayerInstance.ima.addEventListener(google.ima.AdEvent.Type.COMPLETE, function () {
                            $(window).off('scroll.checkTopPosition');
                            videoPlayerInstance.muted(true);
                            videoPlayerInstance.volume(0);
                            destroyInArticlePreroll(videoPlayerInstance);
                        });
                    });

                    $(window).on('scroll.checkTopPosition', $.throttle(500, checkTopPosition));
                }
            }

            // if didomi is not disabled or one of the consents is not given, stop here
            if (didomiDisabled || (consentForBasicAds && consentForPersonalizedAds)) {
                setTimeout(() => {
                    createInArticlePreroll();
                }, 500);
            }
        }
    };


    if (didomiDisabled) {

        inlinePlayerInit();
        setInArticlePreroll();

    } else {

        window.didomiOnReady = window.didomiOnReady || [];
        window.didomiOnReady.push(function (Didomi) {

            consentForBasicAds = Didomi.getUserConsentStatusForPurpose('select_basic_ads');
            consentForPersonalizedAds = Didomi.getUserConsentStatusForPurpose('select_personalized_ads');

            inlinePlayerInit();
            setInArticlePreroll();

        });
    }

});
